import _startsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/starts-with";
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import _ from 'lodash';
import styles from "./FieldIcon.module.css";
import { Icon } from '../../Icon/Icon';
const defaultIconRender = (icon, positionStyles, displayStyles, isFixedWidth) => React.createElement(Icon, {
  icon: icon,
  className: cx(positionStyles, displayStyles),
  isFixedWidth: isFixedWidth
});
export const fieldIconPropTypes = {
  icon: PropTypes.string,
  iconPosition: PropTypes.oneOf(['left', 'right'])
};
export const FieldIcon = props => {
  const field = props.children,
    icon = props.icon,
    iconPosition = props.iconPosition,
    disabled = props.disabled,
    size = props.size,
    className = props.className;
  const renderIcon = _.isFunction(props.renderIcon) ? props.renderIcon : defaultIconRender;
  if (!icon) {
    return field;
  }
  const isRight = iconPosition === 'right';
  const isLeft = !isRight;
  const wrapperClasses = cx(styles.fieldWithIcon, className, {
    [styles.materialIcon]: icon === null || icon === void 0 ? void 0 : _startsWithInstanceProperty(icon).call(icon, 'mi')
  });
  const iconClasses = cx({
    disabled
  }, styles.icon, {
    [styles.iconSmall]: size === 'small',
    [styles.iconLarge]: size === 'large',
    [styles.iconWrapper]: !renderIcon
  });
  const isFixedWidth = true;
  const iconElement = renderIcon(icon, styles.iconWrapper, iconClasses, isFixedWidth);
  return React.createElement("div", {
    className: wrapperClasses
  }, isLeft && iconElement, field, isRight && iconElement);
};
FieldIcon.propTypes = fieldIconPropTypes;
defaultIconRender.__docgenInfo = {
  componentName: "defaultIconRender",
  packageName: "@jutro/components",
  description: "",
  displayName: "defaultIconRender",
  methods: [],
  actualName: "defaultIconRender"
};
FieldIcon.__docgenInfo = {
  componentName: "FieldIcon",
  packageName: "@jutro/components",
  description: "FieldIcon component definition",
  displayName: "FieldIcon",
  methods: [],
  actualName: "FieldIcon",
  metadataType: "element",
  props: {
    icon: {
      type: {
        name: "string"
      },
      required: false,
      description: "MI icon definition"
    },
    iconPosition: {
      type: {
        name: "enum",
        value: [{
          value: "'left'",
          computed: false
        }, {
          value: "'right'",
          computed: false
        }]
      },
      required: false,
      description: "Phrase which indicates where the icon should be placed relative to the text"
    }
  }
};